var FILTER_KEYS;
(function (FILTER_KEYS) {
    FILTER_KEYS["ACTIVATED"] = "Activated";
    FILTER_KEYS["NON_ACTIVATED"] = "Non-Activated";
    FILTER_KEYS["FOAL"] = "Foal";
})(FILTER_KEYS || (FILTER_KEYS = {}));
const inRange = (value, numMin, numMax) => {
    return value >= numMin && value <= numMax;
};
const HorseFilterComparator = {
    name: (row, val) => row.static.displayName.toLowerCase().includes(val.name),
    gender: (row, val) => row.static.gender === val.gender,
    condition: (row, val) => {
        const { isActive, isFoal } = row.volatile;
        switch (val.condition) {
            case FILTER_KEYS.ACTIVATED:
                return isActive;
            case FILTER_KEYS.NON_ACTIVATED:
                return !isActive;
            case FILTER_KEYS.FOAL:
                return isFoal;
            default:
                return false;
        }
    },
    color: (row, val) => { var _a; return (_a = val.color.split(',')) === null || _a === void 0 ? void 0 : _a.includes(row.static.colour); },
    age: (row, val) => inRange(row.volatile.age, val.ageMin, val.ageMax),
    speed: (row, val) => inRange(row.volatile.stats.speed, val.speedMin, val.speedMax),
    stamina: (row, val) => inRange(row.volatile.stats.stamina, val.staminaMin, val.staminaMax),
    acceleration: (row, val) => inRange(row.volatile.stats.acceleration, val.accelerationMin, val.accelerationMax),
    endurance: (row, val) => inRange(row.volatile.stats.endurance, val.enduranceMin, val.enduranceMax),
    agility: (row, val) => inRange(row.volatile.stats.agility, val.agilityMin, val.agilityMax),
    totalStats: (row, val) => inRange(row.volatile.totalStats, val.totalMin, val.totalMax)
};
export default HorseFilterComparator;
